// removed by extract-text-webpack-plugin
module.exports = {"Blog":"k_l","BlogItemTitle":"k_m","BlogList":"k_n","ListImage":"k_o","BlogItem":"k_p","tags":"k_q","tag":"k_r","BlogItemSummary":"k_s","content":"k_t","BlogItemExcerpt":"k_u","SearchHeader":"k_v"};


//////////////////
// WEBPACK FOOTER
// ./src/components/blog/Blog.module.scss
// module id = 332
// module chunks = 0